import React from 'react';
import { AutomatedUnderwriting } from './pages/AutomatedUnderwriting';
export function App() {
  return <AutomatedUnderwriting data-id="element-0" data-mp="35d3j8yd6kgkv" />;
}